import { useLeafletContext } from '@react-leaflet/core'
import L from "leaflet";
import { JSX, useEffect, useState } from "react";

interface SpinnerProps {
  loading: boolean;
}

const Spinner = (props: SpinnerProps): JSX.Element => {
  const context = useLeafletContext()
  const spinner = new L.Control({position: 'topleft'});
  const [prevSpinner, setPrevSpinner] = useState<L.Control>();

  useEffect(() => {

    spinner.onAdd = () => {
      return L.DomUtil.create("div", "spinner-border text-primary font-size-normal");
    };

    if (props.loading)
      spinner.addTo(context.map);
    else
      context.map.removeControl(prevSpinner);

    setPrevSpinner(spinner);

  }, [props.loading]);

  return null;
};

export default Spinner;
